export default __webpack_public_path__ + "static/media/scorpion.b269f55e.svg";